<!--

 -->

<template>
  <div class="gsl-hrm-background-container">
    <div class="gsl-hrm-card-container">
      <oxd-text tag="h6" class="gsl-hrm-main-title">
        {{ $t('attendance.punch_out') }}
      </oxd-text>

      <oxd-divider />

      <!-- wrapper -->
      <div class="gsl-hrm-paper-container">
        <record-attendance
          v-bind="$attrs"
          :logged-emp-number="loggedEmpNumber"
        ></record-attendance>
      </div>
    </div>
  </div>
</template>

<script>
import RecordAttendance from '@/orangehrmAttendancePlugin/components/RecordAttendance.vue';
export default {
  components: {
    'record-attendance': RecordAttendance,
  },
  inheritAttrs: false,
  props: {
    loggedEmpNumber: {
      type: Number,
      default: null,
    },
  },
};
</script>
